import getCustomResponse from './get-custom-response';
import OrchCustomData from './orch-custom-data';
/**
 * Performance optimization
 * collect log events to batch after time-critical items are fired.
 */

// FIFO queue
const queue = [];

// pointer to visaSdk
let vco;

/**
 * sets ref to visaSdk for CALogger interface
 * @param {EMVCOSDK} visaSdk
 * @returns {void}
 */
const setVco = visaSdk => {
  vco = visaSdk;
};

/**
 * "Batch" send all queued events in FIFO manner
 * @returns {void}
 */
const flushEvents = () => {
  while (queue.length > 0) {
    vco.pushEvents(queue.shift());
  }
};

/**
 * Wraps a Promise-like with timings.
 * @param {SDKInstance} instance
 * @param {String} method
 * @param {Any} args: Optional
 * @param {String} network
 * @param {Function} pusher
 * @returns {PromiseLike}
 */
const promiseTimer = (instance, method, args, network, pusher) => {
  if (typeof instance[method] === 'function') {
    const start = Date.now();

    return instance[method](args).then(otherArgs => {
      const end = Date.now();
      pusher(network, start, end, otherArgs);
      return otherArgs;
    });
  }

  throw new Error(`${method} on ${JSON.stringify(instance)} is not a function`);
};

/**
 * Raw event push
 * @param {CALoggerEvent} event
 * @returns {void}
 */
const pushAnyEvent = event => {
  queue.push(event);
};

/**
 * Queues a CALoggerEvent for batch send
 * @param {String} step
 * @param {String} srcInitiatorId
 * @param {Integer} startTime
 * @param {Integer} endTime
 * @param {String} response (Optional)
 * @returns {void}
 */
const pushEvent = (step, srcInitiatorId, startTime, endTime, response) => {
  const tt = endTime - startTime;
  // cleanse sensitive data
  response = response ? getCustomResponse(response) : undefined;

  queue.push({
    E: step,
    ERRCODE: null,
    ERRMSG: null,
    ETIME: endTime,
    LL: 'INFO',
    S: 200,
    STIME: startTime,
    TY: 'RESPONSE',
    checkout_step: step,
    response,
    srcInitiatorId,
    timeTaken: tt
  });
};

/**
 * Convenience method for init events
 * @param {String} network
 * @param {Integer} startTime
 * @param {Integer} endTime
 */
const pushInitEvent = (network, startTime, endTime) => {
  const [step, srcInitiatorId] = [
    `ORCH_INIT_${network}_API_SUCCESS_RESPONSE`,
    OrchCustomData.srcInitiatorId[network]
  ];
  pushEvent(step, srcInitiatorId, startTime, endTime);
};

/**
 * Convenience method for isRecognized events
 * @param {String} network
 * @param {Integer} startTime
 * @param {Integer} endTime
 * @param {Object} res
 * @returns {void}
 */
const pushIsRecognizedEvent = (network, startTime, endTime, res) => {
  const recognized = res ? res.recognized : false;
  const step = `ORCH_IS_RECOGNIZED_${
    recognized ? 'TRUE' : 'FALSE'
  }_${network}_API_SUCCESS_RESPONSE`;

  pushEvent(step, OrchCustomData.srcInitiatorId[network], startTime, endTime, res);
};

export {
  flushEvents,
  promiseTimer,
  pushAnyEvent,
  pushEvent,
  pushInitEvent,
  pushIsRecognizedEvent,
  setVco
};
export default pushEvent;
